import React from 'react'
import classnames from 'classnames'
import inRange from 'lodash/inRange'
import toNumber from 'lodash/toNumber'
import debounce from 'lodash/debounce'

export default class Number extends React.Component {
  state = {
    value: this.props.value,
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.value })
  }

  validate = input => {
    if (input < this.props.min) return this.props.min
    if (input > this.props.max) return this.props.max
    if (input === ' ') return 0
    if (input === 0) return 0
    if (inRange(input, this.props.min, this.props.max + 1))
      return parseInt(input, 10)
  }

  handleUpdate = debounce(
    value =>
      this.setState(
        { value },
        () => this.props.handleUpdate && this.props.handleUpdate(value)
      ),
    1000
  )

  handleChange = e => {
    const input = e.target.value.match(/^[0-9][0-9]*$/g)
    const value = input === null ? ' ' : toNumber(input)
    this.setState({ value }, () => this.handleUpdate(this.validate(value)))
  }

  render() {
    const { minimal, currency, label, message, step } = this.props
    const { value } = this.state
    const classNames = classnames('number', {
      minimal: minimal,
      currency: currency,
    })
    if (isNaN(value)) {
      throw Error('Received NaN for `value` attribute. Must be a Number.')
    }
    return (
      <div className={classNames}>
        {label && <label>{label}</label>}
        <div>
          <input
            type="number"
            value={value}
            step={step}
            onChange={this.handleChange}
          />
        </div>
        {message && <label>{message}</label>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Number.js